import i18n from "@/plugins/i18n"
import abilities from "@/composables/abilities";
import moduleAbilities from "@/composables/moduleAbilities";
import { computed } from "vue";

const qvctSurveyGroup = [
    'qvct-survey-index'
]

export default {
    menus:  computed(()=>(
        {
            sectionTitle: 'QVCT',
            module : [moduleAbilities.QVCT_SURVEY],
            permission: [],
            children: [
                {
                    title: i18n.global.t('menu.qvct_survey.title'),
                    icon: 'fas fa-poll icon-right2',
                    route: 'qvct-survey-index',
                    group: qvctSurveyGroup,
                    id: 'step-qvct-survey',
                   /* permission: [abilities.CAN_VIEW_EVENT, abilities.CAN_VIEW_ALL_EVENT],*/
                    children: [],
                    module: [moduleAbilities.QVCT_SURVEY],
                },
            ]
        }
    ))

}
